import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

import "./styles.css";

import logo from "./logo_ios.png";

export default function Header({ children, handleLanguageChange }) {
  const [lang, setLang] = useState("es");

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    if (lang) {
      setLang(lang);
    } else {
      localStorage.setItem("lang", "es");
    }
  }, []);

  const handleLang = () => {
    setLang(lang === "es" ? "en" : "es");
    if (handleLanguageChange) handleLanguageChange();
    else {
      // const langIndex = LANGUAGES.indexOf(lang)
      // const newLang = LANGUAGES[langIndex + 1] || LANGUAGES[0]
      // setLang(newLang)
      // localStorage.setItem('lang', newLang)
    }
  };

  return (
    <header className="header__guest">
      <img src={logo} alt="" />
      <section className="section__guest">
        {children ? (
          children
        ) : (
          <main className="flex__section__guest">
            <section>
              <button
                className="continua_button btn btn-secondary"
                onClick={handleLang}
              >
                <i className="fa-solid fa-earth-americas fa-xl"></i>
                {lang === "es" ? "Español" : "English"}
              </button>
            </section>
            <section>
              <Link
                to="/onboarding"
                className="continua_button btn btn-primary"
              >
                <i className="fa-solid fa-arrow-right-to-bracket"></i>
                <Trans i18nKey="onboarding.login.btn_login">
                  <span>Inicia sesión</span>
                </Trans>
              </Link>
            </section>
          </main>
        )}
      </section>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx